import { Tag } from 'antd';
import React from 'react';
import { AppColors } from '../Utils/helper/AppColors';
import { getColorSettings } from '../Utils/helper/commonUtils';

export default function CustomTag({
	tagTitle,
	color,
	border,
	backgroundColor,
	pX,
	pY,
	fontSize,
	fontWeight,
	lineHeight,
	colorsInfo,
	borderRadius,
	minWidth,
	maxWidth,
	height,
	onClick,
	cursor = 'text',
}) {	
	
	const localSettingColors = getColorSettings();

	return (
		// DEPARTMENT_TYPE[department] && (
		// 	<Tag style={{ borderRadius: 50, margin: 0 }} color={DEPARTMENT_TYPE[department]?.color || 'blue'}>
		// 		{DEPARTMENT_TYPE[department]?.label || department}
		// 	</Tag>
		// )
		

		<Tag
			style={{
				borderRadius: borderRadius || 30,
				margin: 0,
				backgroundColor: colorsInfo?.bgColor || backgroundColor || localSettingColors.quinary, // Background color
				color: colorsInfo?.color || color || localSettingColors.fontColor, // Text color
				border: '1px solid ',
				borderColor: colorsInfo?.border || border || localSettingColors.tertiary, // Border color
				fontSize: fontSize || 12,
				fontWeight: fontWeight || 600,
				lineHeight: lineHeight || '115%',
				fontFamily: 'Poppins',
				// height: height || '30px',
				display: 'inline-block',
				// justifyContent: 'center',
				alignItems: 'center',
				paddingInline: pX !== undefined ? pX : 12,
				paddingBlock: pY !== undefined ? pY : 5,
				minWidth: minWidth || '80px',
				maxWidth: maxWidth || '200px',
				textAlign: 'center',
				whiteSpace: 'nowrap', // <-- add this
				overflow: 'hidden', // <-- add this
				textOverflow: 'ellipsis', // <-- add this
				cursor: cursor 
			}}
			onClick={onClick}
		>
			{typeof tagTitle === 'string' ? tagTitle : tagTitle}
		</Tag>
	);
}
